import { TomSelectController } from "@finchi/tom-select-coreui"

export class RemoteSelectController extends TomSelectController {
  static values = { url: String }

  get tomSelectOptions() {
    return {
      ...super.tomSelectOptions,
      valueField: "id",
      labelField: "text",
      searchField: "text",
      maxOptions: 20,
      loadThrottle: 200,
      load: (query, callback) => {
        const url = `${this.urlValue}?q=${encodeURIComponent(query)}`
        fetch(url, { headers: { Accept: "application/json" } })
          .then((r) => r.json())
          .then((items) => callback(items))
          .catch(() => callback())
      },
      onChange: () => {
        this.element.dispatchEvent(new Event("change", { bubbles: true }))
      }
    }
  }
}
